import React, { useEffect, lazy, createElement } from 'react';
import { SEO } from '../components/SEO';
export function ArchitectSubmitPage() {
  useEffect(() => {
    // Load Tally embed script
    const script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.async = true;
    script.onload = () => {
      if (typeof (window as any).Tally !== 'undefined') {
        ;
        (window as any).Tally.loadEmbeds();
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <>
      <SEO title="Submit a Project — Aspect" description="Submit a completed or substantially complete project for documentation and review." data-id="element-104" />
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-6 text-aspect-black" data-id="element-106">
          Submit a project
        </h1>
        <p className="text-lg text-aspect-black/80 mb-12" data-id="element-107">
          Submit a completed or substantially complete project for documentation
          and review.
        </p>

        <div className="w-full" style={{
        colorScheme: 'light',
        backgroundColor: '#F6F7F5'
      }} data-id="element-108">
          <iframe data-tally-src="https://tally.so/embed/obDlGN?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" loading="lazy" width="100%" height="1054" frameBorder="0" marginHeight={0} marginWidth={0} title="Architect Intake" className="w-full" data-id="element-109" />
        </div>
      </div>
    </>;
}